import { z } from 'zod';
import { defineEndpoint } from '../define';

export const getPollIdBySlug = defineEndpoint({
  method: 'GET',
  path: '/v1/polls/by-slug/:slug',
  params: z.object({ slug: z.string().min(1).max(80) }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: z.object({ id: z.string().uuid() }) }),
});
